import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Footer() {
  // Link listesi (Senin orijinal kodundaki liste)
  const footerLinks = [
    { label: "CV", path: "/cv" },
    { label: "Yayınlar", path: "/papers" },
    { label: "Projeler", path: "/projects" },
    { label: "Dersler", path: "/courses" },
    { label: "İstatistikler", path: "/statistics" },
    { label: "İletişim", path: "/contact" },
  ];

  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      className="bg-navy text-white mt-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* İletişim Bölümü */}
          <motion.div
            initial={{ x: -20, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h3 className="text-xl font-serif font-bold mb-4">İletişim</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Kırşehir Ahi Evran Üniversitesi
              <br />
              Mühendislik-Mimarlık Fakültesi
              <br />
              Elektrik-Elektronik Mühendisliği Bölümü
              <br />
              Kırşehir, Türkiye
            </p>
          </motion.div>

          {/* Hızlı Bağlantılar - EKSİK OLAN KISIM BURASIYDI, GERİ GELDİ */}
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <h3 className="text-xl font-serif font-bold mb-4">
              Hızlı Bağlantılar
            </h3>
            <ul className="space-y-2 text-sm text-gray-300">
              {footerLinks.map((link, index) => (
                <motion.li
                  key={index}
                  whileHover={{ x: 5, color: "#ffffff" }} // Sağa kayma efekti
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  {/* Link bileşeni kullanıyoruz ki sayfa yenilenmeden geçiş yapsın */}
                  <Link to={link.path} className="block transition-colors">
                    {link.label}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Takip Edin Bölümü */}
          <motion.div
            initial={{ x: 20, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
          >
            <h3 className="text-xl font-serif font-bold mb-4">Takip Edin</h3>
            <p className="text-gray-300 text-sm">
              Akademik profillerimizi ve güncel çalışmalarımızı takip
              edebilirsiniz.
            </p>
          </motion.div>
        </div>

        {/* Telif Hakkı */}
        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-sm text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} Dr. Öğr. Üyesi Memduh Köse. Tüm
            hakları saklıdır.
          </p>
          <p>
            <strong>
              <a href="http://guclu.tr">Güçlü Web</a>
            </strong>{" "}
            Tarafından Geliştirilmiştir
          </p>
        </div>
      </div>
    </motion.footer>
  );
}
